module.exports = __webpack_public_path__ + "static/img/index_plane_image.3cdde75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_plane_image.png
// module id = u4BZ
// module chunks = 1